module.exports = __webpack_public_path__ + "img/gf2.17583da6.png";